import React from 'react';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
import { eventsData } from '../data/eventsData';
import { SEO } from '../utils/seo';
export function EventDetailPage() {
  const id = window.location.pathname.split('/').pop();
  const event = eventsData.find(e => e.id === id);
  if (!event) {
    return <div className="min-h-screen bg-white flex flex-col" data-id="element-417">
        <SEO title="Événement introuvable" description="L'événement que vous recherchez n'existe pas ou a été déplacé" data-id="element-418" />
        <Navbar data-id="element-419" />
        <div className="flex-grow flex flex-col items-center justify-center py-20 px-4 text-center" data-id="element-420">
          <h1 className="text-[48px] font-bold text-arih-dark mb-6" data-id="element-421">
            Événement introuvable
          </h1>
          <p className="text-[18px] text-arih-gray mb-8" data-id="element-422">
            L'événement que vous recherchez n'existe pas ou a été déplacé.
          </p>
          <a href="/evenements" className="inline-flex items-center justify-center rounded-full bg-arih-blue px-[34px] py-[12px] text-[16px] font-semibold text-white hover:bg-blue-800 transition-colors" data-id="element-423">
            Retour aux événements
          </a>
        </div>
        <Footer data-id="element-424" />
      </div>;
  }
  return <div className="min-h-screen bg-white" data-id="element-425">
      <SEO title={event.title} description={event.description} keywords={`${event.title}, événement Agadir, ${event.date}, ARIH événements`} ogImage={event.image} ogType="article" data-id="element-426" />
      <Navbar data-id="element-427" />

      {/* Hero with Background Image */}
      <section className="relative h-[50vh] flex items-center justify-center" style={{
      backgroundImage: `url("${event.image}")`,
      backgroundSize: 'cover',
      backgroundPosition: 'center'
    }} data-id="element-428">
        <div className="absolute inset-0 bg-black/45" data-id="element-429" />
        <div className="relative z-10 text-center px-4 max-w-4xl" data-id="element-430">
          <h1 className="text-[48px] md:text-[70px] font-semibold text-white leading-tight mb-4" data-id="element-431">
            {event.title}
          </h1>
          <p className="text-[22px] text-white/85" data-id="element-432">{event.date}</p>
        </div>
      </section>

      {/* Content */}
      <section className="bg-white py-20 px-4 md:px-8" data-id="element-433">
        <div className="container mx-auto max-w-3xl" data-id="element-434">
          <div className="text-[18px] text-arih-dark leading-[32px] space-y-6" data-id="element-435">
            {event.content.map((paragraph, index) => <p key={index} data-id="element-436">{paragraph}</p>)}
          </div>
        </div>
      </section>

      <Footer data-id="element-437" />
    </div>;
}